export default "__VITE_ASSET__Cylvs0op__"